import { forwardRef, InputHTMLAttributes } from "react";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
    function Input({ className = "", ...props }, ref) {
        return (
            <input
                ref={ref}
                className={`h-11 w-full rounded-lg border border-border bg-surface px-3
                    font-sans text-sm text-ink placeholder:text-ink-faint
                    focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:border-accent
                    disabled:bg-surface-sunken disabled:text-ink-faint ${className}`}
                {...props}
            />
        );
    }
);
